import { Guid } from 'guid-typescript';

export class Article {
    id: Guid;
    title: string = '';
    description: string = '';
    imageUrl: string = '';
    action: string = '';
    actionUrl: string = '';
    category: string = '';
    enabled: boolean = false;
    createdAt: Date;
    order: number = 1;
}
